import {
  appendGOATandCountryCodeToTitle,
  getCategories,
  getText,
} from 'shared/utils/pageMetadataUtils';
import { startCase } from 'shared/utils/startCase';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.getCollectionsMetadata';

export const getCollectionsMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  query,
}) => {
  // Pulling out static strings for translation purposes
  const more = t(`${TP}.more`, 'More');

  const { groups = [] } = constructorResponse?.response || {};
  const { topLevelCategories } = getCategories(groups);

  const topCategories = getText('', topLevelCategories.constructedList);
  const featuringTopCategories =
    topCategories?.length > 0
      ? t(`${TP}.featuringTopCategories`, 'Featuring {topCategories}.', { topCategories })
      : '';

  let topCategoriesWithMore = topLevelCategories.constructedListWithStartCase;
  if (topCategoriesWithMore.length === 5 || topCategoriesWithMore.length === 3) {
    topCategoriesWithMore.splice(-1, 1, more);
  } else if (topCategoriesWithMore.length === 1) {
    topCategoriesWithMore = [...topCategoriesWithMore, ' & ', more];
  }

  const collectionName: string = pageTitle.split(' | ')[0] || startCase(query?.slug);
  const title = getText(`${collectionName}: `, topCategoriesWithMore);
  const description = t(
    `${TP}.description`,
    'Shop the curated {collectionName} collection on GOAT. {featuringTopCategories} Buyer protection guaranteed on all purchases.',
    {
      collectionName,
      featuringTopCategories,
    },
  );

  return {
    pageTitle: appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
